import { FlowNodeTypes } from '../components/types';
export function getActionNodes(actions) {
    const actionNodes = actions.filter((node) => node.nodeType === FlowNodeTypes.ACTION);
    return actionNodes.map((node) => node.id);
}
